/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListRecommendationByCategoryResponse {
    getFixupPrototypeFunction() { return ListRecommendationByCategoryResponse.fixupPrototype; }

    static newInstance(model: Partial<ListRecommendationByCategoryResponse>): ListRecommendationByCategoryResponse {
        let obj = Object.assign(new ListRecommendationByCategoryResponse(), model);
        ListRecommendationByCategoryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListRecommendationByCategoryResponse>): ListRecommendationByCategoryResponse {
        if (!model) return null;
        return ListRecommendationByCategoryResponse.newInstance(<ListRecommendationByCategoryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListRecommendationByCategoryResponse) {
        if (!obj) return;

        models.ListRecommendationByCategoryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListRecommendationByCategoryResponse): boolean {
        Object.setPrototypeOf(obj, ListRecommendationByCategoryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.recommendations) {
            for (let val of this.recommendations) {
                models.RecommendationByCategory.fixupPrototype(val);
            }
        }
    }

    /**
     * Page count
     */
    page_count: number;

    /**
     * Total count
     */
    total_count: number;

    /**
     * Recommendation Details
     */
    recommendations: Array<models.RecommendationByCategory>;

}
